import media from "styled-media-query";
import breakpoints from "Helpers/BreakpointHelper";
import styled from "styled-components";

export const BlockContainer = styled.div`
  background-color: ${({ bgColor, theme }) =>
    bgColor ? bgColor : theme.colors.white};
  padding: ${({ narrowText }) => (narrowText ? "1.25rem 3rem" : "3rem 3rem")};

  ${media.lessThan(breakpoints.ipad)`
  padding: 3rem 1rem;
  
  `}
  ${media.lessThan(breakpoints.mobile)`
  padding: 2rem 0;
  `}
`;
